import React from 'react'
import { AppRouteProps } from '~/routes'
import { useParams } from 'react-router-dom'
import Index from './Pages'
import Create from './Pages/Create'


export default function InterestPointRoutes(): readonly AppRouteProps[] {
    const routes: readonly AppRouteProps[] = [
        {
            path: '/interest-point',
            component: Index,
            isProtected: true,
            permissions: ['interest_point_index'],
        },
        {
            path: '/interest-point/create',
            component: Create,
            isProtected: true,
            permissions: ['interest_point_create'],
        },
    ]

    return routes
}
